export const smoothScrollTo = (targetPosition, duration = 1200) => {
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  if (distance === 0) return Promise.resolve();

  // Função de Easing: easeInOutQuart (início e fim extremamente suaves)
  const easeInOutQuart = (time, start, change, dur) => {
    time /= dur / 2;
    if (time < 1) return (change / 2) * time * time * time * time + start;
    time -= 2;
    return (-change / 2) * (time * time * time * time - 2) + start;
  };

  return new Promise((resolve) => {
    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = easeInOutQuart(timeElapsed, startPosition, distance, duration);
      
      window.scrollTo(0, run);
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        window.scrollTo(0, targetPosition);
        resolve();
      }
    };
    requestAnimationFrame(animation);
  });
};

export const scrollToElement = (id, offset = 80, duration = 1200) => {
  const el = document.getElementById(id);
  if (el) {
    const elementPosition = el.getBoundingClientRect().top;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    let offsetPosition = elementPosition + window.pageYOffset - offset;
    
    // Previne rolagem além do limite da página
    if (offsetPosition > maxScroll) offsetPosition = maxScroll;
    if (offsetPosition < 0) offsetPosition = 0;
    
    return smoothScrollTo(offsetPosition, duration);
  }
  return Promise.resolve();
};

export const scrollWindowToTop = (duration = 1200) => {
  return smoothScrollTo(0, duration);
};